export function initialState({ steps: allSteps, answers = {}, resumeAt = 0, completed = false }) {
  const categoryTitles = Object.fromEntries(
    allSteps.filter((s) => s.type === "category").map((s) => [s.categoryId, s.title]),
  );
  const steps = allSteps.filter((s) => s.type !== "category");
  const shownAt = (i) => allSteps.slice(0, i).filter((s) => s.type !== "category").length;
  const start =
    completed || resumeAt === -1 ? steps.length : shownAt(Math.max(0, Math.min(resumeAt, allSteps.length)));
  return {
    steps,
    categoryTitles,
    index: start,
    answers: { ...answers },
    saving: null, // questionId being saved
    pendingValue: null, // the value being saved, shown as selected meanwhile
    error: null,
    finished: Boolean(completed),
  };
}

export const currentStep = (state) => state.steps[state.index] ?? null;
export const questionSteps = (state) => state.steps.filter((s) => s.type === "question");
export const isDoneScreen = (state) => state.index >= state.steps.length;

export function progress(state) {
  const questions = questionSteps(state);
  const answered = questions.filter((q) => state.answers[q.questionId] !== undefined).length;
  return { answered, total: questions.length };
}

export const categoryTitle = (state, step) => state.categoryTitles?.[step?.categoryId] ?? null;

export function surveyReducer(state, action) {
  switch (action.type) {
    case "next":
      return { ...state, index: Math.min(state.index + 1, state.steps.length), error: null };
    case "back": {
      for (let i = state.index - 1; i >= 0; i--) {
        if (state.steps[i].type === "question") return { ...state, index: i, error: null };
      }
      return state;
    }
    case "goTo":
      return { ...state, index: Math.max(0, Math.min(action.index, state.steps.length)), error: null };
    case "saving":
      return { ...state, saving: action.questionId, pendingValue: action.value, error: null };
    case "saved":
      return {
        ...state,
        saving: null,
        pendingValue: null,
        answers: { ...state.answers, [action.questionId]: action.value },
      };
    case "failed":
      return { ...state, saving: null, pendingValue: null, error: action.message };
    case "finished":
      return { ...state, finished: true, error: null };
    default:
      return state;
  }
}
